import { DateRangeValue } from "../../utils/time";

export enum AiPresencePaths {
    OVERVIEW = '/dashboard/ai-presence/overview',
    ADVERTISING_IMPACT = '/dashboard/ai-presence/advertising-impact',
    TOPICS_TABLE = '/dashboard/ai-presence/topics',
    SHARE_OF_VOICE = '/dashboard/ai-presence/ai-share-of-voice'
}

export interface AiPresenceOverviewPayload extends DateRangeValue {
    accountKey: string;
    brandKey: string;
}

export interface AiPresenceOverviewResponse {
    metrics: {
        brandVisibility: number;
        sentiment: number;
        myShareOfVoice: number;
        visibilityReturn: number;
    };
    trend: {
        brandVisibility: number;
        sentiment: number;
        myShareOfVoice: number;
        visibilityReturn: number;
    };
}

export interface AiPresenceAdvertisingImpactPayload extends DateRangeValue {
    accountKey: string;
    brandKey: string;
}

export interface AiPresenceAdvertisingImpactResponse {
    dailyImpact: {
        date: string;
        impressions: number;
        visibility: number;
    }[];
}

export interface AiPresenceTopicsTablePayload extends DateRangeValue {
    accountKey: string;
    brandKey: string;
}

export interface AiPresenceTopicsTableResponse {
    topics: {
        topic: string;
        visibility?: {
            value: number;
            trend: number;
        };
        sentiment?: {
            value: number;
            sentiment: string;
        };
        topCompetitors?: string[];
    }[];
}

export interface AiPresenceTopicsTableRowData {
    topics: {
        topic: string;
        visibility: {
            value: string;
            trend?: number | string;
            sortValue: number;
        };
        sentiment: {
            value: string;
            trend?: string;
            sortValue: number;
        };
        topCompetitors?: string[];
    }[];
}

export interface AiPresenceShareOfVoicePayload extends DateRangeValue {
    accountKey: string;
    brandKey: string;
    topic?: string;
}

export interface AiPresenceShareOfVoiceResponse {
    topics: string[]; // FOR FILTERS
    brands: {
        brand: string;
        share?: {
            value: number;
            trend: number;
        };
        sentiment?: {
            value: number;
            sentiment: string;
        };
    }[];
}

export interface AiPresenceShareOfVoiceRowData {
    brands: {
        brand: string;
        share: {
            value: string;
            trend?: number;
            sortValue: number;
        };
        sentiment: {
            value: string;
            trend?: string;
            sortValue: number;
        };
    }[];
}

export enum ShareOfVoiceTriggerSource {
    INITIAL_LOAD,
    TOPIC_CHANGE
}